<template>
  <div class="guide-list">
    <dl v-if="guideList.length > 0">
      <dd v-for="(d_item, d_index) in guideList">
        <p>{{ d_item.title}}</p>
        <dt v-for="(t_item, t_index) in d_item.itemList">
          <router-link v-bind:to="'/'+ lan + '/detail/' +d_item.groupId +'/' + t_item.id">{{ t_item.title }}</router-link>
        </dt>
      </dd>
    </dl>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'GuideList',
    props: ['guideList'],
    data() {
      return {
        lan: this.$route.params.language
      }
    },
    mounted() {
      console.log(this.guideList);
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .guide-list{
    font-family: PingFangSC-Regular;
    color: #000000;
    dl{
      display: flex;
    }
    dd{
      flex: 1;
      padding-left: 40px; 
      p{
        font-size: 20px;
        position: relative;
        margin: 20px 0 30px 0;
        line-height: 1;
        &:before{
          content:'';
          position: absolute;
          left: -40px;
          top: 5px;
          width: 10px;
          height: 10px;
          background: #FFD78E;
          border-radius: 2px;
        }
      }
      dt{
        font-size: 16px;
        color: #737373;
        letter-spacing: 0.23px;
        line-height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GuideList.vue?3038699d